<template>
  <div class="profile-form">
    <v-row>
      <v-col cols="12" md="7" class="py-0">
        <v-text-field
          v-model="parentProfileForm.description"
          :rules="rules.descriptionRules"
          label="Description :"
          persistent-hint
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="7" class="py-0">
        <v-text-field
          v-model="parentProfileForm.label"
          :rules="rules.labelRules"
          label="Label :"
          persistent-hint
        ></v-text-field>
      </v-col>
    </v-row>

    <v-alert outlined type="warning" prominent border="left">
      To limit access to web only, add the following attribute: Colubris-AVPair
      => USE-ACCESS-LIST=webonly <br />
      <br />

      To prevent from any internet access, add the following attribute:
      Colubris-AVPair => USE-ACCESS-LIST=rien<br />
      <br />

      To limit download bandwidth, add the following attribute: Colubris-AVPair
      => max-input-rate=VALEUR_EN_KBPS<br />
      <br />

      To limit upload bandwidth, add the following attribute: Colubris-AVPair =>
      max-output-rate=VALEUR_EN_KBPS<br />
      <br />

      To assign a VLAN, put the 3 following attributes:<br />
      Tunnel-Type => 13 <br />
      Tunnel-Medium-Type => 6 <br />
      Tunnel-Private-Group-ID => VLAN_ID <br />
    </v-alert>

    <v-btn small color="primary" @click="addAttribute()">
      <v-icon left>mdi-plus</v-icon> Ajouter un attribut
    </v-btn>

    <template v-for="(attribute, idx) in parentProfileForm.attributes">
      <div :key="attribute.id">
        <v-row>
          <v-col cols="5">
            <v-select
              :items="attributesChoice"
              item-text="text"
              item-value="value"
              v-model="parentProfileForm.attributes[idx].name"
            ></v-select>
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="parentProfileForm.attributes[idx].value"
              label="value"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-btn @click="removeAttribute(idx)" icon
              ><v-icon>mdi-delete</v-icon></v-btn
            >
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
</template>
<script>
import { computed } from "@vue/composition-api";

export default {
  props: {
    profileForm: Object,
    attributesChoice: Array,
    rules: Object,
  },
  setup(props, { emit }) {
    /* Computed */
    const parentProfileForm = computed({
      get: () => props.profileForm,
      set: (value) => {
        emit("update:profileForm", value);
      },
    });

    const removeAttribute = (idx) => {
      parentProfileForm.value.attributes.splice(idx, 1);
    };
    const addAttribute = () => {
      parentProfileForm.value.attributes.push({
        name: props.attributesChoice[0].value,
        value: "",
      });
    };

    return {
      parentProfileForm,
      removeAttribute,
      addAttribute,
    };
  },
};
</script>
